// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__tUKii","selects":"Documents_selects__23ucT"};